import { render, staticRenderFns } from "./XDivider.vue?vue&type=template&id=01bba7a1&scoped=true&"
import script from "./XDivider.vue?vue&type=script&lang=js&"
export * from "./XDivider.vue?vue&type=script&lang=js&"
import style0 from "./XDivider.vue?vue&type=style&index=0&id=01bba7a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bba7a1",
  null
  
)

export default component.exports